import { html, render } from "lit-html";
import { clockString } from "./util";

const xx = html`<div class="team-side">
        <div style="font-size: calc(150%);" class="scoreboard-text">HOME</div>
        <div id="home-score" class="big-led" style="width: 3ch;">&nbsp;0</div>
        <div style="display: flex; flex-direction: row; width:100%;">
            <div style="padding:10px 0px 0px 10px;" class="scoreboard-text">
                PLYR
            </div>
            <div style="flex-grow: 1;"></div>
            <div style="padding-top:10px;" class="scoreboard-text">PENALTY</div>
        </div>
        <div id="home-penalty-1" style="width: 8ch;" class="small-led"></div>
        <div id="home-penalty-2" style="width: 8ch;" class="small-led"></div>
    </div>
    <div class="middle">
        <span id="main-clock" class="big-led">12:14</span>
        <div style="display: flex; align-items: center;">
            <div class="scoreboard-text">PERIOD</div>
            <div id="period" class="small-led">0</div>
        </div>
        <div style="flex-grow: 1;"></div>
        <div id="shots-box" style="display: flex; width:100%">
            <div
                style="margin-left: 10px; width: 3ch;"
                id="home-shots"
                class="small-led"
            >
                000
            </div>
            <div style="flex-grow: 1;"></div>
            <div
                style="margin-right: 10px; width: 3ch;"
                id="guest-shots"
                class="small-led"
            >
                000
            </div>
        </div>
        <div style="margin: 0px 5px 5px 5px;" class="scoreboard-text">
            SHOTS ON GOAL
        </div>
    </div>
    <div class="team-side">
        <div style="font-size: calc(150%);" class="scoreboard-text">GUEST</div>
        <div id="guest-score" class="big-led" style="width: 3ch;">&nbsp;0</div>
        <div style="display: flex; flex-direction: row; width:100%;">
            <div style="padding:10px 0px 0px 10px;" class="scoreboard-text">
                PLYR
            </div>
            <div style="flex-grow: 1;"></div>
            <div style="padding-top:10px;" class="scoreboard-text">PENALTY</div>
        </div>
        <div id="guest-penalty-1" style="width: 8ch;" class="small-led"></div>
        <div id="guest-penalty-2" style="width: 8ch;" class="small-led"></div>
    </div>`;

export interface Penalty {
    playerNumber: number;
    time: number;
}

export class Scoreboard {
    private homeShots: number;
    private guestShots: number;
    private homeScore: number;
    private guestScore: number;
    private homePenalties: Penalty[];
    private guestPenalties: Penalty[];
    private period: number;
    private periodElement: HTMLElement;
    private homeShotsElement: HTMLElement;
    private guestShotsElement: HTMLElement;
    private homeScoreElement: HTMLElement;
    private guestScoreElement: HTMLElement;
    private mainClockElement: HTMLElement;

    constructor() {
        render(xx, document.getElementById("scoreboard")!);

        this.homeShots = 0;
        this.guestShots = 0;
        this.homeScore = 0;
        this.guestScore = 0;
        this.homePenalties = [];
        this.guestPenalties = [];
        this.period = 0;

        this.periodElement = document.getElementById("period")!;
        this.homeShotsElement = document.getElementById("home-shots")!;
        this.guestShotsElement = document.getElementById("guest-shots")!;
        this.homeScoreElement = document.getElementById("home-score")!;
        this.guestScoreElement = document.getElementById("guest-score")!;
        this.mainClockElement = document.getElementById("main-clock")!;
    }

    public reset(): void {
        this.setGuestScore(0);
        this.setHomeScore(0);
        this.setMainClockVal(0);
        this.clearGuestPenalties();
        this.clearHomePenalties();
        this.setGuestShots(0);
        this.setHomeShots(0);
        this.setPeriod(0);
    }

    public getHomeScore(): number {
        return this.homeScore;
    }

    public getGuestScore(): number {
        return this.guestScore;
    }

    public setHomeScore(s: number): void {
        this.homeScore = s;
        if (this.homeScore < 0) this.homeScore = 99; // It's really 999
        this.homeScoreElement.innerHTML = this.homeScore.toString();
    }

    public setGuestScore(s: number): void {
        this.guestScore = s;
        if (this.guestScore < 0) this.guestScore = 99; // It's really 999
        this.guestScoreElement.innerHTML = this.guestScore.toString();
    }

    public getHomePenalties(): Penalty[] {
        return this.homePenalties;
    }

    public getGuestPenalties(): Penalty[] {
        return this.guestPenalties;
    }

    public hasPenalties(): boolean {
        return this.homePenalties.length + this.guestPenalties.length > 0;
    }

    public nextPeriod(): void {
        this.setPeriod(this.period + 1);
    }

    public setPeriod(p: number): void {
        this.period = p % 10;
        this.periodElement.innerHTML = this.period.toString();
    }

    public adjustHomeShots(val: number): void {
        this.setHomeShots(this.homeShots + val);
    }

    public setHomeShots(val: number): void {
        this.homeShots = val;
        if (this.homeShots < 0) this.homeShots = 0;
        this.homeShotsElement.innerHTML = this.homeShots.toString();
    }

    public adjustGuestShots(val: number): void {
        this.setGuestShots(this.guestShots + val);
    }

    public setGuestShots(val: number): void {
        this.guestShots = val;
        if (this.guestShots < 0) this.guestShots = 0;
        this.guestShotsElement.innerHTML = this.guestShots.toString();
    }

    public adjustHomeScore(val: number): number {
        this.setHomeScore(this.homeScore + val);
        return this.homeScore;
    }

    public adjustGuestScore(val: number): number {
        this.setGuestScore(this.guestScore + val);
        return this.guestScore;
    }

    public setMainClockVal(val: number): void {
        const millis = val % 1000;
        let tenths = Math.floor(millis / 100);

        if (tenths > 0) {
            val += 1000;
            tenths = 0;
        }

        const seconds = Math.floor(val / 1000) % 60;
        const mins = Math.floor(val / 60000);

        const zeroPad = (num: number): string => {
            return num.toString().padStart(2, "0");
        };

        this.mainClockElement.innerHTML = `${zeroPad(mins)}:${zeroPad(
            seconds
        )}`;
    }

    public addGuestPenalty(info: Penalty): void {
        this.guestPenalties.push(info);
        this.displayPenalties();
    }

    public addHomePenalty(info: Penalty): void {
        this.homePenalties.push(info);
        this.displayPenalties();
    }

    public clearHomePenalties(): void {
        this.homePenalties = [];
        this.displayPenalties();
    }

    public clearGuestPenalties(): void {
        this.guestPenalties = [];
        this.displayPenalties();
    }

    public deleteGuestPenalty(num: number): void {
        this.guestPenalties.splice(num, 1);
        this.displayPenalties();
    }

    public deleteHomePenalty(num: number): void {
        this.homePenalties.splice(num, 1);
        this.displayPenalties();
    }

    public adjustPenalties(val: number): void {
        this.homePenalties = this.homePenalties.filter(
            (x) => (x.time += val) > 0
        );
        this.guestPenalties = this.guestPenalties.filter(
            // "1000" becuase we don't care about tenths and prefer not to display a zero.
            // If we actually cared about the fidelity of this clock, the penalty timers
            // would have their timers.
            (x) => (x.time += val) >= 1000
        );

        this.displayPenalties();
    }

    public displayPenalties(): void {
        for (let i = 0; i < 2; i++) {
            this.displayPenalty("home", this.homePenalties[i], i);
            this.displayPenalty("guest", this.guestPenalties[i], i);
        }
    }

    public displayPenalty(side: string, penalty: Penalty, num: number): void {
        const div = document.getElementById(`${side}-penalty-${num + 1}`)!;
        if (penalty) {
            div.innerHTML = `${penalty.playerNumber} ${clockString(
                penalty.time,
                {
                    leftTrim: "&nbsp;",
                }
            )}`;
        } else {
            div.innerHTML = "&nbsp;";
        }
    }
}

export default new Scoreboard();
